import axios from 'axios';

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_UNDERWRITING_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to manually set XSRF token for cross-origin requests
// This is needed because Axios 1.6+ only auto-sends XSRF tokens for same-origin requests
axiosInstance.interceptors.request.use((config) => {
  // Only add XSRF token for state-changing requests
  if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
    // Extract XSRF-TOKEN from cookies
    const token = document.cookie
      .split(';')
      .map((cookie) => cookie.trim().split('='))
      .find((cookieKV) => cookieKV[0] === 'XSRF-TOKEN')?.[1];

    if (token) {
      // Laravel expects the token to be decoded
      // eslint-disable-next-line no-param-reassign
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
    }
  }
  return config;
}, (error) => Promise.reject(error));

export default axiosInstance;
